var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		'app',
		{
			'full-width': _vm.isWhiteBackgroundSet,
			'with-background': !_vm.isWhiteBackgroundSet && !_vm.hasNoLayout,
		}
	],attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.displayEmailModal && _vm.showEmailModal)?_c('update-email-overlay',{on:{"toggleModalDisplay":_vm.toggleModalDisplay}}):_vm._e()],1),(_vm.showPromo)?_c('promotional-dialog',{attrs:{"close":_vm.closePromo}}):_vm._e(),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.showFlash)?_c('flash-message',{attrs:{"message":_vm.message,"type":_vm.messageType}}):_vm._e()],1),(_vm.loading)?_c('app-loader',{attrs:{"is-loading":_vm.loading,"is-background":true,"loader-class":'white-loader'}}):_vm._e(),(_vm.isLandingPage)?_c('div',{staticClass:"banner-container"},[_c('text-banner')],1):_vm._e(),_c('div',{class:{
			'tv-platfrom': _vm.tvPlatform,
			'container': !_vm.hasNoLayout,
			'container-dark': _vm.isDarkBGRouteSet,
			'set-header-position': _vm.isLandingPage
		}},[(!_vm.hasNoLayout)?_c('kidjo-navigation-header',{staticClass:"header-background-color",class:{
				'light': !_vm.isWhiteBackgroundSet,
				'dark': _vm.isWhiteBackgroundSet,
				'login-register-header': _vm.isRegisterOrLogin,
			}}):_vm._e(),_c('div',{class:{
				'content': !_vm.hasNoLayout,
			}},[(_vm.initialized)?_c('router-view'):_vm._e()],1),(!_vm.tvPlatform && !_vm.hasNoLayout)?_c('kidjo-footer',{class:{
				'light': _vm.isWhiteBackgroundSet,
				'dark-bg-footer': _vm.isDarkBGRouteSet,
				'login-register-footer': _vm.isRegisterOrLogin
			},attrs:{"id":"footer"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }